import React from "react"
import styled from "styled-components"
import { HeadingOne } from "buoy-core"
import Button from "../Button"
import { breakpoints, colors } from "buoy-theme"
import responsive from "../../common/responsive"
import { generatePageUrl, getImageUrl } from "../../common/utils"

const HeroSection = styled.header`
  position: relative;
  background-color: ${colors.landingBackground};
  display: flex;
  flex-direction: column;
  text-align: center;
  ${responsive(
    "justify-content",
    "center",
    "center",
    "flex-start",
    "flex-start"
  )} align-items: center;
  ${responsive("height", "85vh", "620px", "500px", "440px")} width: 100%;
  z-index: 1;
`

const HeroImage = styled.div`
  position: absolute;
  width: 100vw;
  left: 0;
  ${responsive("height", "100vh", "735px", "535px", "465px")}
  overflow-x: hidden;
  ${props => responsive(
    'background-image',
    `url(${props.image.xl})`,
    `url(${props.image.lg})`,
    `url(${props.image.md})`,
    `url(${props.image.sm})`
  )}
  background-repeat: no-repeat;
  ${responsive(
    "background-position",
    "42% bottom",
    "48% bottom",
    "60% bottom",
    "60% bottom"
  )}
  ${responsive(
    "background-size",
    "auto 95vh",
    "auto 700px",
    "auto 350px",
    "auto 225px"
  )}
  ${responsive("top", "-10%", "-10", "0", "0")}
  z-index: -1;
`
const StyledHeadingOne = styled(HeadingOne)`
  ${responsive("margin-top", "0", "0", "124px", "112px")}
  ${responsive("margin-bottom", "25px", "25px", "12px", "12px")}
  ${responsive("max-width", "450px", "450px", "350px", "350px")}
  padding: 0 20px;
  text-align: center;
`

const Hero = ({ headline, button, image, symptomCheckerPath, innerRef }) => (
  <HeroSection innerRef={innerRef}>
    <HeroImage image={image} />
    <StyledHeadingOne>{headline}</StyledHeadingOne>
    <Button href={generatePageUrl(symptomCheckerPath)} large arrow>
      {button}
    </Button>
  </HeroSection>
)

class HeroContainer extends React.Component {
  constructor(props) {
    super(props)
    let imgSrc = getImageUrl(props.image + "?auto=format,compress&crop=fit&px=16&blur=200")

    this.state = {
      image: {
        sm: imgSrc + "&h=930",
        md: imgSrc + "&h=1110",
        lg: imgSrc + "&h=1500",
        xl: imgSrc + "&h=3000",
      }
    }
  }

  componentDidMount() {
    const hdImage = new Image()
    let imgSrc = getImageUrl(this.props.image + "?auto=format,compress&crop=fit")
    let newState = { image : {} }
    let screenWidth = window.innerWidth

    if (screenWidth <= breakpoints.sm) {
      hdImage.src = imgSrc + "&h=950"
      newState = {
        image: {
          sm: hdImage.src,
          md: imgSrc + "&h=1110",
          lg: imgSrc + "&h=1500",
          xl: imgSrc + "&h=3000",
        }
      }
    }
    else if (screenWidth <= breakpoints.md) {
      hdImage.src = imgSrc + "&h=1110"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: imgSrc + "&h=1500",
          xl: imgSrc + "&h=3000",
        }
      }
    }
    else if (screenWidth <= breakpoints.lg) {
      hdImage.src = imgSrc + "&h=1500"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: hdImage.src,
          xl: imgSrc + "&h=3000",
        }
      }
    }
    else {
      hdImage.src = imgSrc + "&h=3000"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: hdImage.src,
          xl: hdImage.src,
        }
      }
    }

    hdImage.onload = () => {
      this.setState(newState)
    }
  }

  render() {
    return <Hero {...this.props} {...this.state} />
  }
}

export { HeroContainer as default }



// WEBPACK FOOTER //
// ./src/components/Hero/index.js